import { isObject } from '../../../shared/utils/jsUtils/isObject/isObject';
import { DatabaseFoodItem } from '../../interfaces/DatabaseFoodItem';
import { FoodDetails } from '../../interfaces/FoodDetails';
import { FoodListItem } from '../../interfaces/FoodListItem';

const KEY_PREFIX = 'food-template:';

const getKey = (tid: string) => `${KEY_PREFIX}${tid}`;

/**
 * Prefill handoff to the React food form via `/add-food/<type>?template=<tid>`. Entries are removed
 * only after a successful save or by logout's `localStorage.clear()` - there is no expiry.
 */
export const foodTemplateStorage = {
  set(food: FoodListItem | DatabaseFoodItem | FoodDetails): string {
    const tid = Date.now().toString(36);
    const template: FoodDetails = {
      ...food,
      id: 0,
      activeCalendar: false,
      microNutrients: food.microNutrients ?? [],
    };

    localStorage.setItem(getKey(tid), JSON.stringify(template));

    return tid;
  },

  /** null for a missing key and for anything that does not parse to an object */
  get(tid: string): FoodDetails | null {
    const stored = localStorage.getItem(getKey(tid));

    if (!stored) {
      return null;
    }

    try {
      const parsed: unknown = JSON.parse(stored);

      return isObject(parsed) ? (parsed as FoodDetails) : null;
    } catch {
      return null;
    }
  },

  remove(tid: string): void {
    localStorage.removeItem(getKey(tid));
  },
};
